import React, { useState } from "react";
import "../../styles/desktop/gestao.css";

import UserConfigIcon from "../../assets/svg/userConfig";
import IconSobre from "../../assets/svg/sobre";
import LogoutIcon from "../../assets/svg/logoutIcon";

import UserConfig from "./userconfig/userconfig.js";
import Sobre from "./TelaSobre/sobre.js";

export default function Gestao() {
    const [popupAtivoSobre, setPopupAtivoSobre] = useState(false);
    const [popupAtivoUserConfig, setPopupAtivoUserConfig] = useState(false);
    const [popupConfirmacaoLogout, setPopupConfirmacaoLogout] = useState(false);

    const handleAbrirSobre = () => {
        setPopupAtivoSobre(true);
    };
    
    const handleAbrirUserConfig = () => {
        setPopupAtivoUserConfig(true);
    };

    const handleFecharUserConfig = () => {
        setPopupAtivoUserConfig(false);
    };

    const handleAbrirConfirmacaoLogout = () => {
        setPopupConfirmacaoLogout(true);
    };

    const handleFecharConfirmacaoLogout = () => {
        setPopupConfirmacaoLogout(false);
    };

    const handleLogout = () => {
        sessionStorage.removeItem("user");
        window.location.href = "https://acesso-app.cmd-automacao.com/";
    };

    return (
        <div className="GestaoContent">
            {popupAtivoUserConfig ? (
                <div className="userConfigOverlay">
                    <UserConfig onBack={handleFecharUserConfig} />
                </div>
            ) : (
                <>
                    {popupAtivoSobre && (
                        <div className="popupOverlay">
                            <div className="popupContent">
                                <Sobre />
                            </div>
                        </div>
                    )}

                    {popupConfirmacaoLogout && (
                        <div className="popupOverlay-sair">
                            <div className="popupContent-sair">
                                <h2>Confirmar Logout</h2>
                                <p>Tem certeza de que deseja sair?</p>
                                <div className="popupButtons">
                                    <button className="btnConfirmar" onClick={handleLogout}>
                                        Sim
                                    </button>
                                    <button className="btnCancelar" onClick={handleFecharConfirmacaoLogout}>
                                        Não
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="GestaoModal">
                        <div className="objetoGestao" onClick={handleAbrirUserConfig}>
                            <div className="tituloGestao">
                                <UserConfigIcon width={75} height={75} />
                                <h1 id="txtGestao">Configuração de usuário</h1>
                            </div>
                        </div>

                        <div className="objetoGestao" onClick={handleAbrirSobre}>
                            <div className="tituloGestao">
                                <IconSobre width={75} height={75} />
                                <h1 id="txtGestao">Sobre</h1>
                            </div>
                        </div>

                        <div className="objetoGestao" onClick={handleAbrirConfirmacaoLogout}>
                            <div className="tituloGestao">
                                <LogoutIcon width={100} height={100} />
                                <h1>Sair</h1>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
